module.exports = __webpack_public_path__ + "media/assets/icons/right-caret-6caa736b01110683b71780d3cfff85fc.svg";